import _sfc_main from "./SettingControl.vue2.mjs";
import "./SettingControl.vue3.mjs";
import normalizeComponent from "../../_virtual/_plugin-vue2_normalizer.mjs";
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c("div", { staticClass: "setting-control-container" }, [_c(_setup.IconButton, { attrs: { "is-active": _setup.showSettingDialog, "title": _setup.t("Settings") }, on: { "click-icon": _setup.handleShowSettingDialog } }, [_c(_setup.SettingIcon)], 1)], 1);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "08afa494"
);
const SettingControl = __component__.exports;
export {
  SettingControl as default
};
